import React from 'react';
import clsx from 'clsx';
import styles from './CardTitle.module.scss';

type CardTitleProps = React.ComponentProps<'h3'>;

export const CardTitle: React.FC<CardTitleProps> = ({ children, className, ...props }) => {
    return (
        <h3
            className={clsx(styles.title, className)}
            {...props}
        >
            {children}
        </h3>
    );
};
